import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import Delete from '@mui/icons-material/Delete';

import {
  Alert,
  AppBar,
  Box,
  CircularProgress,
  Divider,
  Grid,
  ListSubheader,
  MenuItem,
  Paper,
  Tab,
  Tabs,
} from '@mui/material';

import {
  Button,
  ColourPicker,
  DatePicker,
  Editor,
  FileUpload,
  ImagePicker,
  Page,
  Select,
  Switcher,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { KnowledgeCourse } from '../../../models/KnowledgeCourse';

import HelpersLanguage from '../../../actions/helpers/language';
import { Questionnaire } from '../../../models/Questionnaire';

const { DateTime } = require("luxon");

type Props = {}

export const CoachCourseEdit: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();
  const queryClient = useQueryClient();
  // const { state } = useLocation();
  
  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [mainObject, setMainObject] = useState<KnowledgeCourse>({
    name: ''
  });
  const [currentLanguageId, setCurrentLanguageId] = useState<number>(1);
  const [currentLanguage, setCurrentLanguage] = useState<string>('nl');
  const [clapped, setClapped] = useState<number[]>([]);
  const [itemCleared, setItemCleared] = useState<boolean>(false);
  const [bgItemCleared, setBgItemCleared] = useState<boolean>(false);
  const [item, setItem] = useState<File>();
  const [bgItem, setBgItem] = useState<File>();
  const [bgItemUrl, setBgItemUrl] = useState<string>();
  const [itemUrl, setItemUrl] = useState<string>();

  const [errors, setErrors] = useState<{[z:string]: boolean}>({});

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["knowledge_course", (login?.practice_id || currentPractice?.id), objectId],
    queryFn: () =>
      fetch_one<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_course',
          id: objectId,
          fields: [
            'id', 'name', 'extra_data'
          ],
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    // select: (d) => {
    //   return {
    //     ...d,
    //     birth_date: DateTime.fromISO(d.birth_date).toFormat("dd/LL/y")
    //   };
    // },
    enabled: !!(login?.practice_id || currentPractice?.id) && parseInt(objectId || '', 10) > 0,
  });

  const {
    data: questionnaires,
    // isLoading: objectsLoading,
    // isError: objectsError,
    isSuccess: questionnairesSuccess,
    refetch: questionnairesRefetch,
  } = useQuery({
    queryKey: ["coach", "questionnaires", (login?.practice_id || currentPractice?.id)],
    queryFn: () =>
      fetch_all<Questionnaire>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'questionnaire',
          fields: ['id', 'name', 'content_type'],
          order: 'name ASC',
          per_page: 200,
          page: 0,
          filter: {
            search: '',
            advanced: {
              only_for_knowledge: 1,
              practice_id: (login?.practice_id || currentPractice?.id)
            }
          },
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    enabled: !!(login?.practice_id || currentPractice?.id),
  });








  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
      keepOpen?: boolean
    }) => {
      return fetch_one<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setSavedOpen(true);
      queryClient.invalidateQueries({ queryKey: ["coach", "knowledge_courses", (login?.practice_id || currentPractice?.id)] });
      if (!variables.keepOpen) navigate("/knowledge_courses");
      if (!!variables.keepOpen && objectId === 'new') navigate(`/knowledge_course/${data.id}`);
      if (!!variables.keepOpen && objectId !== 'new') objectRefetch();
    },
  });





  const saveObject = (keep_open: boolean) => {
    mutationSave.mutate({
      formData: {
        object: 'knowledge_course',
        handler_id: login?.id,
        practice_id:  (login?.practice_id || currentPractice?.id),
        fields: ['id'],
        id: mainObject?.id,
        ob: {
          practice_id: (login?.practice_id || currentPractice?.id),
          ...mainObject
        }
      },
      keepOpen: keep_open
    });
  };

  let page_title;
  if (typeof((object || {}).id) === 'undefined') {
    page_title = t("general.titles.add", "Nieuwe") + " " + t("coach.models.knowledge_courses.singular", "Cursus");
  } else {
    page_title = t("general.titles.edit", "Wijzig") + " " + (object || {}).name;
  }

  useEffect(() => {
    if (params.id !== 'new') objectRefetch();
  }, [params.id]);
  useEffect(() => {
    if (!!objectSuccess) setMainObject(object);
  }, [object]);
  useEffect(() => {
    let err:any = {};
    if (!mainObject.name) err.name = true;
    // if ((mainObject.extra_data?.questions || []).length < 1) err.questions = true;

    setErrors(err);
  }, [mainObject]);

  return <Page
    title={page_title}
    titleCrumbs={[
      {
        title: t("coach.menu.knowledge_courses", "Cursussen"),
        path: "/knowledge_courses"
      }
    ]}
  >
    <Paper sx={{padding: 2}}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5">{t("coach.submenu.course_sections.basic")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            id="name"
            caption={t("general.knowledge_courses.fields.name")}
            starred
            value={mainObject.name || ''}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                name: e
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
         <TextInput
            id="teaser"
            caption={t("general.knowledge_courses.fields.teaser")}
            starred
            multiline
            value={mainObject.teaser || ''}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                teaser: e
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Switcher
            id="is_background_colour"
            caption={t("general.knowledge_courses.fields.is_background_colour")}
            value={(mainObject?.extra_data?.is_background_colour || '0') === '1'}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                extra_data: {
                  ...(mainObject?.extra_data || {}),
                  is_background_colour: !!c ? '1' : '0'
                }
              });
            }}
          />
        </Grid>
        {(mainObject?.extra_data?.is_background_colour || '0') === '1' && <Grid item xs={12} md={6}>
          <ColourPicker
            label={t("general.knowledge_courses.fields.background_colour")}
            value={mainObject?.extra_data?.background_colour || 'rgba(0, 0, 0, 0.4)'}
            onChange={(v) => {
              setMainObject({
                ...mainObject,
                extra_data: {
                  ...(mainObject?.extra_data || {}),
                  background_colour: v
                }
              });
            }}
          />
        </Grid>}
        {(mainObject?.extra_data?.is_background_colour || '0') !== '1' && <Grid item xs={12} md={6}>
          <Typography sx={{fontSize: '0.8rem'}}>{t("general.knowledge_courses.fields.background_image")}</Typography>
          <ImagePicker
            existing={mainObject?.get_item}
            deleteable
            backend
            item={bgItem}
            itemUrl={bgItemUrl}
            onSelect={(_item:File|undefined, _itemUrl:string|undefined) => {
              setBgItem(_item);
              setBgItemUrl(_itemUrl);
              setMainObject({
                ...mainObject,
                item: _item,
                itemUrl: _itemUrl
              });
              if (!_item && !_itemUrl) {
                setBgItemCleared(true);
              } else {
                setBgItemCleared(false);
              }
            }}
          />
        </Grid>}
        <Grid item xs={12}>
          <Typography variant="h5">{t("coach.submenu.course_sections.content")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography sx={{fontSize: '0.8rem'}}>{t("general.knowledge_courses.fields.body")} *</Typography>
          <Editor
            simple
            label=""
            value={mainObject.body || ''}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                body: e
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography sx={{fontSize: '0.8rem'}}>{t("general.knowledge_courses.fields.video")}</Typography>
          <ImagePicker
            existing={mainObject?.get_video}
            deleteable
            backend
            item={item}
            itemUrl={itemUrl}
            onSelect={(_item:File|undefined, _itemUrl:string|undefined) => {
              setItem(_item);
              setItemUrl(_itemUrl);
              setMainObject({
                ...mainObject,
                video: _item,
                videoUrl: _itemUrl
              });
              if (!_item && !_itemUrl) {
                setItemCleared(true);
              } else {
                setItemCleared(false);
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">{t("coach.submenu.course_sections.general")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="enabled"
            caption={t("general.knowledge_courses.fields.enabled")}
            value={!!mainObject?.enabled}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                enabled: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="hidden"
            caption={t("general.knowledge_courses.fields.is_hidden")}
            value={!!mainObject?.is_hidden}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_hidden: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="is_frontpage"
            caption={t("general.knowledge_courses.fields.is_frontpage")}
            value={!!mainObject?.is_frontpage}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_frontpage: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            id="cost"
            caption={t("general.knowledge_courses.fields.cost")}
            starred
            value={mainObject.mollie_data?.cost || ''}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                mollie_data: {
                  ...(mainObject?.mollie_data || {}),
                  cost: !!e ? e.replace(/[^0-9\,\.]/g, '').replace(",", ".") : ''
                }
              });
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">{t("coach.submenu.course_sections.subjects")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="is_open_order"
            caption={t("general.knowledge_courses.fields.is_open_order")}
            value={!!mainObject?.is_open_order}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_open_order: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12}>
            [...subjects...]
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">{t("coach.submenu.course_sections.finish")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="is_emails"
            caption={t("general.knowledge_courses.fields.is_emails")}
            value={!!mainObject?.is_emails}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_emails: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="is_approvable"
            caption={t("general.knowledge_courses.fields.is_approvable")}
            value={!!mainObject?.is_approvable}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_approvable: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            fullWidth
            caption={t("general.knowledge_courses.fields.review_id")}
            backend
            displayEmpty
            id="review_id"
            value={mainObject.review_id?.toString() || ''}
            setValue={(v) => {
              setMainObject({
                ...mainObject,
                review_id: !!v ? parseInt(v.toString(), 10) : undefined
              });
            }}
          >
            <MenuItem value=''>--- ---</MenuItem>
            {(questionnaires || []).filter(fff => fff.content_type === 'review').map(questionnaire => <MenuItem value={questionnaire.id}>{questionnaire.name}</MenuItem>)}
          </Select>
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            fullWidth
            caption={t("general.knowledge_courses.fields.quiz_id")}
            backend
            displayEmpty
            id="quiz_id"
            value={mainObject.quiz_id?.toString() || ''}
            setValue={(v) => {
              setMainObject({
                ...mainObject,
                quiz_id: !!v ? parseInt(v.toString(), 10) : undefined
              });
            }}
          >
            <MenuItem value=''>--- ---</MenuItem>
            {(questionnaires || []).filter(fff => fff.content_type === 'quiz').map(questionnaire => <MenuItem value={questionnaire.id}>{questionnaire.name}</MenuItem>)}
          </Select>
        </Grid>
        







        <Grid item xs={12} sx={{
          alignContent: 'baseline',
          textAlign: 'center',
          position: {
              xs: 'relative',
              md: 'sticky'
            },
          bottom: '-24px',
          backgroundColor: 'white',
          zIndex: 1201
        }}>
          <Divider sx={{marginTop: 1, marginBottom: 0}} />

          {!!mutationSave.isPending && <CircularProgress />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.save")}
            id='save'
            disabled={Object.keys(errors).length > 0}
            contained
            onClick={(v) => {
              saveObject(false);
            }}
            sx={{marginBottom: 1, marginTop: 1}}
          />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.save_keep_open")}
            id='save_opened'
            disabled={Object.keys(errors).length > 0}
            contained
            onClick={(v) => {
              saveObject(true);
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.cancel")}
            id='cancel'
            text
            // contained
            onClick={(v) => {
              navigate("/knowledge_courses");
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />}
        </Grid>
      </Grid>
    </Paper>
    
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Page>;
}
